import Phaser from "phaser";
import VenueDefinition from "./VenueDefinition";
import {AppContext} from "./BaseWorldScene";

export default class BootScene extends Phaser.Scene {
    constructor(
        public appContext: AppContext,
        public venue: VenueDefinition,
        public tutorialScene: string | null,
        public firstScene: string
    ) {
        super({
            key: 'BootScene'
        });
    }

    preload() {
        this.venue.preload(this)
    }

    create() {
        this.venue.postload(this)
        let tutorialDone = localStorage.getItem('tutorialDone');
        if(!this.tutorialScene || tutorialDone) {
            this.scene.start(this.firstScene);
            this.appContext.gameContext.setCurrentRoom(this.firstScene)
        }
        else {
            this.scene.start(this.tutorialScene);
            this.appContext.gameContext.setCurrentRoom(this.tutorialScene)
        }

    }
}
